import { generated } from '@varos/research-sdk-api';
import { HiOutlineMail, HiOutlineGlobeAlt } from 'react-icons/hi';
import { SharePopoverController } from './sharePopoverInterface';
import { SharePopoverControllerProps, SharePopoverViewProps } from './sharePopoverProps';

export function createSharePopoverController(): SharePopoverController {
    return {
        useProps(context, item, props): Omit<SharePopoverViewProps, 'children'> {
            return {
                menu: {
                    popover: props.disclosure.popover,
                    items: [
                        {
                            kind: 'action',
                            label: 'Capture email',
                            // secondary: 'Require respondents to provide their email',
                            secondary: null,
                            Icon: HiOutlineMail,
                            action: {
                                kind: 'switch',
                                switch: {
                                    isChecked: props.field.captureEmail.value,
                                    onChange(event) {
                                        props.field.captureEmail.onChange(
                                            event.target.checked
                                        );
                                    },
                                },
                            },
                        },
                        {
                            kind: 'action',
                            label: 'Access',
                            // secondary: 'Control who can fill out this form',
                            secondary: null,
                            Icon: HiOutlineGlobeAlt,
                            action: {
                                kind: 'select',
                                options: props.field.accessLevel.options,
                                select: {
                                    value: props.field.accessLevel.value,
                                    onChange(event) {
                                        props.field.accessLevel.onChange(
                                            event.target
                                                .value as generated.FormAccessLevel
                                        );
                                    },
                                },
                            },
                        },
                        {
                            kind: 'divider',
                        },
                        {
                            kind: 'link',
                            label: 'Form link',
                            link: {
                                value: item.link.url,
                            },
                        },
                    ],
                },
            };
        },
    };
}
